import React from 'react';
import { 
    Container,
    Box,
    Link,
    Grid,
    Typography,
    Divider
} from '@material-ui/core';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import LineImg from '../res/img/Line.png'
import './ContactUs.css';

// import ContactUsImg from '../res/img/contact-us-1.jpg';


export default function CookiePolicy() {
    return (
        <Container className="containerContactUs" maxWidth="md">
            <Box className="boxContactUs">
                <Box component="h1" mt={0} mb={5} fontWeight="normal" fontSize="50px" textAlign="center">Contact Us</Box>
                <Divider className="hrFade"/>
                <Box className="boxContactUsDetail" textAlign="center" mt={5} py={5}>
                    <Box component="h1" display="flex" alignItems="center" justifyContent="center">
                        <Box mr={2} display="flex" alignItems="center" justifyContent="center">
                            <EmailIcon fontSize='large' />
                        </Box>
                        <Link href="mailto:amo@klickerlab.com" underline="none" color='inherit'>amo@klickerlab.com</Link>
                    </Box>
                    
                    <Box component="h1" display="flex" alignItems="center" justifyContent="center">
                        <Box mr={2} display="flex" alignItems="center" justifyContent="center">
                            <img src={LineImg} className='line-img'/>
                        </Box>
                        <Link href="https://line.me/ti/p/~@amo-support" underline="none" color='inherit'>@amo-support</Link>
                    </Box>
                    
                    <Box component="h1" display="flex" alignItems="center" justifyContent="center">
                        <Box mr={2} display="flex" alignItems="center" justifyContent="center">
                            <PhoneIcon fontSize='large' />
                        </Box>
                        <Link href="tel:+66960953400" underline="none" color='inherit'>096-095-3400</Link>
                    </Box>
                </Box>
            </Box>
            
        </Container>
    )
}